// Cloudinary configuration and upload helper (React SDK Integration)
import { Cloudinary } from "@cloudinary/url-gen";

// Initialize Cloudinary instance
export const cld = new Cloudinary({
  cloud: {
    cloudName: 'dwrujwvkg'
  }
});

/**
 * Uploads a file to Cloudinary using an unsigned upload preset.
 * You must create an unsigned upload preset in your Cloudinary Dashboard:
 * Settings -> Upload -> Upload presets -> Add upload preset (Mode: Unsigned)
 * @param {File} file - The file to upload.
 * @returns {Promise<Object>} - The Cloudinary upload response.
 */
export async function uploadFileToCloudinary(file) {
  const cloudName = 'dwrujwvkg';
  const uploadPreset = 'cloud-point'; // Replace with your actual unsigned preset name
  const formData = new FormData();
  
  formData.append('file', file);
  formData.append('upload_preset', uploadPreset);

  const res = await fetch(`https://api.cloudinary.com/v1_1/${cloudName}/auto/upload`, {
    method: 'POST',
    body: formData,
  });
  
  if (!res.ok) {
    const errorData = await res.json();
    throw new Error(errorData.error?.message || 'Cloudinary upload failed');
  }
  
  return await res.json();
}

/**
 * Force download a file from a URL.
 */
export function downloadFromCloudinary(url, fileName = 'download') {
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
// function downloadFromCloudinary(url) {
//   const link = document.createElement('a');
//   link.href = url;
//   link.download = '';
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// }
